var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDisplayed)?_c('Banner',_vm._b({on:{"click":_vm.sendMarketingData,"close":_vm.closeBanner},nativeOn:{"click":function($event){return _vm.sendMarketingData($event)}}},'Banner',_vm.props,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }